import { createAction, props } from '@ngrx/store';
import { PatientFamilyHistory } from '../../../models/patient-family-history';

export const getPatientFamilyHistories = createAction('[Patient Family History] Get Patient Family Histories');

export const getPatientFamilyHistoriesSuccess = createAction(
  '[Patient Family History] Get Patient Family Histories Success',
  props<{
    patientFamilyHistories: PatientFamilyHistory[];
    pageNumber: number;
    isAtEndOfData: boolean;
    totalRecordCount: number;
  }>()
);

export const getPatientFamilyHistoriesFailure = createAction(
  '[Patient Family History] Get Patient Family Histories Failure',
  props<{ error: unknown }>()
);

export const setPageNumber = createAction('[Patient Family History] Set Page Number', props<{ pageNumber: number }>());

export const getAllPatientFamilyHistories = createAction(
  '[Patient Family History] Get All Patient Family Histories',
  props<{ patientId: number }>()
);

export const getAllPatientFamilyHistoriesSuccess = createAction(
  '[Patient Family History] Get All Patient Family Histories Success',
  props<{ patientFamilyHistories: PatientFamilyHistory[]; patientId: number; loadedAt: number }>()
);

export const getAllPatientFamilyHistoriesFailure = createAction(
  '[Patient Family History] Get All Patient Family Histories Failure',
  props<{ error: unknown }>()
);

export const invalidateFamilyHistoryCache = createAction('[Patient Family History] Invalidate Family History Cache');

export const recordPatientFamilyHistoryPrintEvent = createAction(
  '[Patient Family History] Record Print Event',
  props<{ patientId: number; patientFamilyHistoryIds: number[] }>()
);

export const recordPatientFamilyHistoryPrintEventSuccess = createAction(
  '[Patient Family History] Record Print Event Success'
);

export const recordPatientFamilyHistoryPrintEventFailure = createAction(
  '[Patient Family History] Record Print Event Failure',
  props<{ error: unknown }>()
);
